<template>
  <div class="form-group col-md-12">
    <label for="inputUser3" class="control-label">{{label}}</label>
    <b-form-input :name="name" type="number" class="form-control"
        :value="value" size="sm" aria-multiline="" :min="min" :max="max"
        @input.native="$emit('input',$event.target.value)"
        :placeholder="placeholder" trim>
    </b-form-input>
  </div>
  <!-- <b-form-group
    :label="label" label-cols="3" 
    label-size="sm"
  >
    <b-form-input :name="name" type="number"
        :value="value" size="sm" aria-multiline="" :min="min" :max="max"
        @input.native="$emit('input',$event.target.value)"
        :placeholder="placeholder" trim>
    </b-form-input>
  </b-form-group> -->
</template>
<script>
export default {
  name: 'NumberInput',
  props: ['placeholder', 'label', 'name', 'value', 'min', 'max']
}
</script>


// WEBPACK FOOTER //
// src/components/Generator/NumberInput.vue